import * as tslib_1 from "tslib";
import "es6-promise";
import { Component, Vue } from "vue-ext";
import axios from "axios";
import VueRouter from "vue-router";
import PortalVue from "portal-vue";
import VueAnalytics from 'vue-analytics';
import "components";
import { routes } from "routes";
import "polyfills";
import { UI, Cart, State } from "store";
var router = new VueRouter({
    linkActiveClass: "active",
    base: "designer",
    mode: "hash",
    routes: routes
});
Vue.use(VueRouter);
Vue.use(PortalVue);
var Root = /** @class */ (function (_super) {
    tslib_1.__extends(Root, _super);
    function Root() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.viewportTooNarrow = false;
        return _this;
    }
    Root.prototype.mounted = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, code, targetRoute;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (/Trident\/|MSIE/.test(window.navigator.userAgent)) {
                            window.addEventListener('hashchange', this.hashChangeHandler);
                        }
                        axios.defaults.baseURL = window.location.pathname;
                        document.body.addEventListener("click", this.closeLayers);
                        window.addEventListener('beforeunload', function (e) {
                            if (_this.$state.dirty && !_this.$state.proshop && !_this.$state.externalEmbed) {
                                (e || window.event).returnValue = _this.$ui.texts.navigateToStartPopupText.text;
                                return _this.$ui.texts.navigateToStartPopupText.text;
                            }
                        });
                        window.addEventListener("resize", this.windowResize);
                        return [4 /*yield*/, this.loadConfiguration(this.$route.query.language)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, axios.get("IsProshopUser")];
                    case 2:
                        data = (_a.sent()).data;
                        this.$state.isProshopUser = data;
                        code = this.$route.query.code;
                        this.$state.proshop = this.$route.query.proshop == "1";
                        this.$state.vertex = this.$route.query.vertex == "1";
                        this.$state.fusion = this.$route.query.fusion == "1";
                        this.$state.store = this.$route.query.store == "1";
                        this.$state.prodlib = this.$route.query.prodlib == "1";
                        this.$state.disableAccessories = this.$state.externalEmbed && this.$route.query.disableAccessories == "1";
                        this.loadAnalytics();
                        targetRoute = "/";
                        if (!code) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.$store.cart.setDesignerCode(code)];
                    case 3:
                        _a.sent();
                        if (this.$store.cart.isCurrentCodeValidWorktopCode) {
                            targetRoute = "/worktop";
                        }
                        else if (this.$store.cart.isCurrentCodeValidBackpanelCode) {
                            targetRoute = "/backpanel";
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (this.$state.externalEmbed) {
                            if (this.$router.currentRoute.path == "/")
                                targetRoute = "/worktop";
                            else
                                targetRoute = this.$router.currentRoute.path;
                        }
                        _a.label = 5;
                    case 5:
                        this.$router.push(targetRoute);
                        this.windowResize();
                        return [2 /*return*/];
                }
            });
        });
    };
    Root.prototype.setActiveEmbedMedia = function (embedMedia) {
        this.$ui.activeEmbedMedia = embedMedia;
    };
    Root.prototype.loadAnalytics = function () {
        if (!this.$configuration.analyticsCode)
            return;
        Vue.use(VueAnalytics, {
            id: this.$configuration.analyticsCode,
            router: router,
            autoTracking: {
                skipSamePath: true,
            },
            set: [
                { field: "dimension1", value: this.$state.proshop },
                { field: "dimension2", value: this.$state.fusion },
                { field: "dimension3", value: this.$state.isProshopUser },
                { field: "dimension4", value: this.$state.vertex } //Is vertex embed ?
            ]
        });
    };
    Object.defineProperty(Root.prototype, "summaryStepNumber", {
        get: function () {
            return this.$state.disableAccessories ? "5." : "6.";
        },
        enumerable: true,
        configurable: true
    });
    Root.prototype.windowResize = function () {
        this.viewportTooNarrow = window.innerWidth < 980;
        this.$ui.isTabletView = window.innerWidth < 1300;
    };
    Root.prototype.scrollMedia = function (scrollDelta) {
        var scrollContent = document.getElementsByClassName("other-media")[0];
        var scrollPosition = scrollContent.scrollLeft;
        var newScrollPosition = scrollPosition + scrollDelta;
        if (newScrollPosition < 0)
            newScrollPosition = 0;
        scrollContent.scrollLeft = newScrollPosition;
    };
    Root.prototype.gotoStart = function () {
        this.$cart.resetState();
        this.$cart.resetCart();
        this.$ui.navigateToStartPopupOpen = false;
        this.$ui.exitConfirmed = true;
        this.loading = false;
        this.$router.push("/");
        this.$ui.exitConfirmed = false;
    };
    Root.prototype.setLanguage = function (code) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$ui.languagesVisible = false;
                        return [4 /*yield*/, this.loadUi(code)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Root.prototype.toggleCart = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.$ui.minicartVisible) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$cart.populateSummary()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.$cart.products.length <= 0)
                            return [2 /*return*/];
                        this.$ui.minicartVisible = !this.$ui.minicartVisible;
                        return [2 /*return*/];
                }
            });
        });
    };
    Root.prototype.embedClasses = function (embedMedia) {
        var classes = ["media"];
        if (this.$ui.activeEmbedMedia.previewImage == embedMedia.previewImage)
            classes.push("active");
        if (embedMedia.embedCode)
            classes.push("video");
        return classes;
    };
    Root.prototype.closeLayers = function () {
        this.$ui.helpVisible = false;
        this.$ui.minicartVisible = false;
        this.$ui.languagesVisible = false;
    };
    Root.prototype.loadUi = function (code) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        url = "configuration" + (code ? "?language=" + code : "");
                        return [4 /*yield*/, axios.get(url)];
                    case 1:
                        data = (_a.sent()).data;
                        this.$store.configuration = data;
                        this.$store.ui = new UI(this.$state, data);
                        if (this.$store.cart) {
                            this.$store.cart.ui = this.$store.ui;
                            this.$store.cart.config = data;
                        }
                        else {
                            this.$store.cart = new Cart(this.$state, this.$ui, data);
                        }
                        return [4 /*yield*/, this.$cart.populateSummary()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.$cart.refreshCart()];
                    case 3:
                        _a.sent();
                        this.$state.disabledWorktopLocation = this.$store.configuration.language == "sv";
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Root.prototype.loadConfiguration = function (code) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$store.state = new State();
                        return [4 /*yield*/, this.loadUi(code)];
                    case 1:
                        _a.sent();
                        this.$store.ready = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Root.prototype, "unavailableViewStyles", {
        get: function () {
            return {
                "background-image": "url('" + this.$ui.texts.frontpageMain.images[0] + "')"
            };
        },
        enumerable: true,
        configurable: true
    });
    Root.prototype.hashChangeHandler = function () {
        var target = window.location.hash;
        this.$router.push(target.substring(1, target.length));
    };
    Root = tslib_1.__decorate([
        Component({ router: router })
    ], Root);
    return Root;
}(Vue));
export default Root;
